import { render } from "./hashtag_link.vue?vue&type=template&id=c545d9d6"
import script from "./hashtag_link.js?vue&type=script&lang=js"
export * from "./hashtag_link.js?vue&type=script&lang=js"

import "./hashtag_link.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__